<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<app-header-card [title]="'KO Phase'">
  <div class="buttons-container">
      <button mat-flat-button color="primary" (click)="openThirdPlaceDialog()">
          3rd Place Match
      </button>
    <button mat-raised-button color="primary" [routerLink]="'..'">Back to Overview</button>
    <button mat-flat-button color="primary" (click)="openCopyPublicLinkDialog()">
      Public live page
      <mat-icon>share</mat-icon>
    </button>
  </div>
</app-header-card>

@if (this.isInitialLoading) {
  <div class="center-content">
    <mat-spinner></mat-spinner>
  </div>
} @else if (this.showErrorMessage) {
  <div class="center-content">
    @if (this.noStandingsFound) {
      <div class="no-matches-container">
        <h1>Its empty here</h1>
        <h2>
          It seems like there are no standings for the knockout phase yet. <br />
          Make sure that the qualification phase is completed and that the standings are generated.
        </h2>
        <button
          mat-flat-button
          [color]="'primary'"
          [routerLink]="'..'"
          data-cy="generate-knockout-phase-standings-btn"
        >
          Back to Overview
        </button>
      </div>
    } @else {
      <h1>There was an error loading the data.</h1>
    }
  </div>
} @else {
  <form class="edit-knockout-phase-tree-form">
    @if (this.tree !== undefined) {
      <app-knockout-phase-tree-node
        [node]="this.tree"
        [template]="nodeTemplate"
      ></app-knockout-phase-tree-node>
    }
  </form>
}

<ng-template
  #nodeTemplate
  let-matchId="id"
  let-team="team"
  let-table="table"
  let-preceedingStandings="preceedingStandings"
  let-parentMatchHasTableAssigned="parentMatchHasTableAssigned"
>
  <div class="qualification-match-container">
    @if (!preceedingStandings || preceedingStandings.length === 0) {
      <mat-card class="beginner-team-node" appearance="outlined">
        <mat-card-content class="edit-knockout-phase-tree-card">
          <div class="team-name-flex">
            <div>
              {{ team?.name ?? '&nbsp;' }}
            </div>
            <button
              data-cy="mark-drinks-picked-up-btn"
              mat-icon-button
              aria-label="Mark team drinks as picked up for this match"
              (click)="markTeamDrinksPickedUp(matchId, team)"
              [disabled]="
                teamHasPickedUpDrinksForMatch(matchId, team) || !parentMatchHasTableAssigned
              "
              [matTooltip]="'Mark team drinks as picked up for this match'"
            >
              <mat-icon class="material-icons-outlined">sports_bar</mat-icon>
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    } @else {
      @if (table !== undefined && table !== null && table.name !== undefined) {
        <div class="table">
          {{ table.name }}
        </div>
      }
      <mat-card class="ko-match-node" appearance="outlined">
        <mat-card-content class="edit-knockout-phase-tree-card">
          <div class="team-name-selectable-flex">
            <mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Team</mat-label>
              <mat-select
                data-cy="select-ko-winner-team"
                [disabled]="canSelectMatchWinner(matchId) || updateInProgress"
                (selectionChange)="this.onChange(matchId, $event)"
                value="{{ team?.id ?? this.noWinnerYetValue }}"
              >
                @for (team of this.getTeamOptions(matchId); track team.id) {
                  <mat-option value="{{ team.id }}">{{ team.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (!isFinalKoStanding(matchId)) {
              <button
                data-cy="mark-drinks-picked-up-btn"
                mat-icon-button
                aria-label="Mark team drinks as picked up for this match"
                (click)="markTeamDrinksPickedUp(matchId, team) || updateInProgress"
                [disabled]="
                  !teamCanPickUpDrinksForMatch(matchId, team) || !parentMatchHasTableAssigned
                "
                [matTooltip]="'Mark team drinks as picked up for this match'"
              >
                <mat-icon class="material-icons-outlined">sports_bar</mat-icon>
              </button>
            }
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>
</ng-template>
